import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class UpdatePortChargesPaymentsService {

  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

  /**
   * Get BLs with paid Port Charges
   * entered as Port Charges without invoice
   */
  getBLs(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/transactions/bls/paid-port-charges`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get units for which the Port Charges have been paid
   * in the selected BL.
   */
  getUnits(bl_no: string): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/transactions/paid-port-charges/get-units/${bl_no}`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Update Port Charges payments
   * @param bl_no
   * @param amount
   * @returns
   */
  updatePortChargesPayments(bl_no:string, amount: any): Observable<any> {

    let apiURL:string=`${this.baseURL}/v1/transactions/update-port-charges`;

    const data = {
      bl_no:bl_no,
      amount: amount
    };

    return this.http.post<any>(apiURL, data);
  }
}
